import Swiper from 'swiper';
export default class Carousel {
    constructor() {
        this.defaultConfig = {
            direction: 'horizontal',
            watchOverflow: true,
            centeredSlides: true,
            grabCursor: true,
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            on: {
                beforeInit() {
                    const swiper = this;
                    if (swiper.params.effect !== 'mask')
                        return;
                    swiper.params.slidesPerView = 1;
                    swiper.params.slidesPerColumn = 1;
                    swiper.params.slidesPerGroup = 1;
                    swiper.params.watchSlidesProgress = true;
                    swiper.params.spaceBetween = 0;
                    swiper.params.virtualTranslate = true;
                    swiper.params.loop = false;
                    swiper.params.autoplay.waitForTransition = false;
                    swiper.originalParams.slidesPerView = 1;
                    swiper.originalParams.slidesPerColumn = 1;
                    swiper.originalParams.slidesPerGroup = 1;
                    swiper.originalParams.watchSlidesProgress = true;
                    swiper.originalParams.spaceBetween = 0;
                    swiper.originalParams.virtualTranslate = true;
                    swiper.originalParams.loop = false;
                    swiper.originalParams.autoplay.waitForTransition = false;
                },
                setTranslate() {
                    const swiper = this;
                    if (swiper.params.effect !== 'mask')
                        return;
                    let count = swiper.slides.length;
                    for (let i = 0; i < count; i++) {
                        if (i == swiper.activeIndex) {
                            swiper.slides[swiper.activeIndex].style.zIndex = count;
                            swiper.slides[i].style.visibility = "visible";
                        }
                        else if (i == swiper.previousIndex) {
                            swiper.slides[swiper.previousIndex].style.zIndex = count - 1;
                            swiper.slides[i].style.visibility = "visible";
                        }
                        else {
                            swiper.slides[i].style.zIndex = 0;
                            swiper.slides[i].style.visibility = "hidden";
                        }
                    }
                },
                slideChange: function () {
                    const swiper = this;
                    if (swiper.params.effect !== 'mask')
                        return;
                    let count = swiper.slides.length;
                    for (let i = 0; i < count; i++) {
                        if (i == swiper.activeIndex) {
                            swiper.slides[swiper.activeIndex].style.zIndex = count;
                            swiper.slides[i].style.visibility = "visible";
                        }
                        else if (i == swiper.previousIndex) {
                            swiper.slides[swiper.previousIndex].style.zIndex = count - 1;
                            swiper.slides[i].style.visibility = "visible";
                        }
                        else {
                            swiper.slides[i].style.zIndex = 0;
                            swiper.slides[i].style.visibility = "hidden";
                        }
                    }
                },
                setTransition: function (speed) {
                    const swiper = this;
                    if (swiper.params.effect !== 'mask')
                        return;
                }
            }
        };
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        this.initSwiper();
    }
    initSwiper() {
        let heroSwipers = document.querySelectorAll('.hero-swiper, .content-swiper');
        if (heroSwipers.length > 0) {
            for (var i = 0; i < heroSwipers.length; i++) {
                var hero = heroSwipers[i];
                var slides = hero.querySelectorAll('.swiper-slide');
                if (slides.length > 1) {
                    let configAttributes = hero.getAttribute("swiper-config");
                    let config = configAttributes ? JSON.parse(configAttributes) : {};
                    let swiperConfig = Object.assign(this.defaultConfig, config);
                    let mySwiper = new Swiper(hero, swiperConfig);
                }
            }
        }
    }
}
